'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';

const StatusBarGettingStarted = () => {
  return /*#__PURE__*/_jsxs(UIRouterLink, {
    className: "status-bar-header-button-long",
    size: "extra-small",
    to: "/getting-started",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "sprocket"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "DesignEditorsUI.statusBar.header.gettingStarted"
    })]
  });
};

export default StatusBarGettingStarted;